export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/aQrEqRjMdYQhRSjtcsxmtn/Visual_bible.png'

const PRECONNECT_ORIGINS: Array<{ href: string; crossOrigin?: boolean }> = [
  { href: 'https://fonts.googleapis.com' },
  { href: 'https://fonts.gstatic.com', crossOrigin: true },
  { href: 'https://cdn.magicpatterns.com', crossOrigin: true },
  { href: 'https://connect.facebook.net' },
  { href: 'https://embed.fliki.ai' }
]

let installed = false

export function installResourceHints(): void {
  if (typeof document === 'undefined' || installed) return
  installed = true

  PRECONNECT_ORIGINS.forEach(({ href, crossOrigin }) => {
    const link = document.createElement('link')
    link.rel = 'preconnect'
    link.href = href
    if (crossOrigin) link.crossOrigin = 'anonymous'
    document.head.appendChild(link)
  })

  const preload = document.createElement('link')
  preload.rel = 'preload'
  preload.as = 'image'
  preload.href = HERO_IMAGE
  preload.setAttribute('fetchpriority', 'high')
  document.head.appendChild(preload)
}
